import { createApiRef } from '@backstage/core-plugin-api';

/**
 * Backstage documentation adoption for a single registered item (a GitLab group or project).
 */
export interface BackstageAdoptionDto {
  /** The command/product name of the item. */
  name: string;
  /** True when the item is a GitLab group, false when it is a single project. */
  isGroup: boolean;
  /** Whether the item documents an OpenAPI definition (any repo, for a group). */
  openApi: boolean;
  /** Whether the item documents an AsyncAPI definition (any repo, for a group). */
  asyncApi: boolean;
  /** Whether the item has TechDocs (mkdocs) integration docs (any repo, for a group). */
  mkDoc: boolean;
  /** UTC time of the last adoption scan, or null if never scanned. */
  checkedAt: string | null;
  /** Full URL to the GitLab group or project. */
  repositoryLink: string;
}

export interface BackstageAdoptionApi {
  getAll(): Promise<BackstageAdoptionDto[]>;
}

export const backstageAdoptionApiRef = createApiRef<BackstageAdoptionApi>({
  id: 'plugin.backstage-adoption.api',
});
